/* istanbul ignore file */

import { FileReader as IonFileReader } from '@ionic-native/file/ngx';
import SparkMD5 from 'spark-md5';
import { DirectUploadFile } from './direct_upload';

export class FileChecksum {
  file: DirectUploadFile;
  chunkSize: number;
  chunkCount: number;
  chunkIndex: number;
  callback: (error: Error | string, checksum?: string) => void;
  md5Buffer;
  fileReader: IonFileReader;

  private isCordova: boolean;

  static create(file: DirectUploadFile, callback: (error: Error, checksum: string) => void) {
    const instance = new FileChecksum(file);
    instance.create(callback);
  }

  constructor(file) {
    this.file = file;
    this.chunkSize = 2097152; // 2MB
    this.chunkCount = Math.ceil(this.file.size / this.chunkSize);
    this.chunkIndex = 0;
    this.isCordova = false;
  }

  create(callback: (error: Error, checksum: string) => void): void {
    this.callback = callback;
    this.md5Buffer = new SparkMD5.ArrayBuffer();
    this.fileReader = new FileReader();
    if (this.fileReader._realReader) {
      // use the real fileReader (not the one overriden by cordova-plugin-file)
      this.fileReader = this.fileReader._realReader;
      this.isCordova = true;
    }
    this.fileReader.addEventListener('load', event => this.fileReaderDidLoad(event));
    this.fileReader.addEventListener('error', event => this.fileReaderDidError(event));
    this.readNextChunk();
  }

  fileReaderDidLoad(event) {
    this.md5Buffer.append(event.target.result);

    if (!this.readNextChunk()) {
      const binaryDigest = this.md5Buffer.end(true);
      const base64digest = btoa(binaryDigest);
      this.callback(null, base64digest);
    }
  }

  fileReaderDidError(event) {
    this.callback(`Error reading ${this.file.name}`);
  }

  readNextChunk() {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const fileSlice = File.prototype.slice || File.prototype['mozSlice'] || File.prototype['webkitSlice'];

    if (this.chunkIndex < this.chunkCount || (this.chunkIndex === 0 && this.chunkCount === 0)) {
      const start = this.chunkIndex * this.chunkSize;
      const end = Math.min(start + this.chunkSize, this.file.size);
      let bytes;
      if (this.isCordova) {
        bytes = this.file.slice(start, end);
      } else {
        bytes = fileSlice.call(this.file, start, end);
      }

      this.fileReader.readAsArrayBuffer(bytes);
      this.chunkIndex++;
      return true;
    } else {
      return false;
    }
  }
}
